"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var YourSavingsCard_1 = require("./YourSavingsCard");
exports.default = YourSavingsCard_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PromoPanel/YourSavingsCard/index.js
// module id = 760
// module chunks = 8